import Skeleton from 'react-loading-skeleton';

const radiusClasses = {
  full: 'rounded-full',
  md: 'rounded-md',
  sm: 'rounded-sm',
};

const PaypalButtonSkeleton = ({
  className = '',
  height,
  rounded = 'full',
  fill = true,
  skeletonClassName = '',
}) => {
  const radiusClass = radiusClasses[rounded] || radiusClasses.full;
  const containerClass = `absolute animate-pulse ${fill ? 'inset-0' : ''} ${className}`.trim();
  const skeletonClass = `${fill ? 'w-full' : ''} ${radiusClass} ${skeletonClassName}`.trim();
  const skeletonProps = {
    count: 1,
    className: skeletonClass,
  };

  if (height !== undefined) {
    skeletonProps.height = height;
  }

  return (
    <div className={containerClass}>
      <Skeleton {...skeletonProps} />
    </div>
  );
};

PaypalButtonSkeleton.propTypes = {
  className: PropTypes.string,
  height: PropTypes.number,
  rounded: PropTypes.oneOf(Object.keys(radiusClasses)),
  fill: PropTypes.bool,
  skeletonClassName: PropTypes.string,
};

export default PaypalButtonSkeleton;
